import { Redirect, Switch, useRouteMatch } from "react-router";
import RouteWrapper from "../Helpers/RouteWrapper";

export function CreateModule({ baseUrl, navigation, layout }) {
  const match = useRouteMatch();

  return (
    <Switch>
      {navigation.links.map(({ route, component }) => (
        <RouteWrapper
          navigation={navigation}
          baseurl={baseUrl}
          key={route}
          path={`${match.url}/${route}`}
          component={component}
          layout={layout}
        />
      ))}
      <Redirect to={`${match.url}/${navigation.links[0].route}`} />
    </Switch>
  );
}
